<template>
<div class="row">
  <div class="col px-md-2 px-3">
    <b-input-group class="mt-0">
    <b-form-input class="search-input" placeholder="Search news" v-model="search_term" @keyup="updateSearch"></b-form-input>
    <b-input-group-append>
      <button type="button" class="btn btn-success px-4" @click="updateSearch"><i class="fas fa-search"></i></button>
    </b-input-group-append>
  </b-input-group>
  <div class="text-center pt-1" v-if="search_term"><small><a href="#/" @click="clearSearch"><i class="fa-solid fa-circle-xmark mr-1"></i>clear search</a></small></div>
  </div>
</div>
</template>

<script>

export default {

  data() {
    return {
      search_term: null,
    };
  },

  methods: {

    updateSearch() {
        this.$emit('update-search', this.search_term);
    },

    // handleEnterKey(event) {
    //   if (event.keyCode === 13) {
    //     this.updateSearch();
    //   }
    // },

    clearSearch() {
        this.search_term = null;
        this.$emit('update-search', this.search_term);
    },

  }

}

</script>

<style scoped>
.search-input, .search-input:focus, .search-input:active, .search-input:hover{
  border-radius:5px !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.btn{
  border-radius: 5px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
</style>